import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { headingStyles } from '@helpers/typography';
import styled from 'styled-components';
import { m } from 'framer-motion';
const Container = styled(m.button) `
  ${ButtonReset}
  ${transition('background-color, border-color, color')}

  --iconSize: 8px;
  --size: 88px;

  display: flex;
  background: var(--bgColor);
  border: 1px solid var(--fgColor);
  border-radius: 50%;
  color: var(--fgColor);
  flex-direction: column;
  height: var(--size);
  place-content: center;
  place-items: center;
  text-align: center;
  width: var(--size);
  z-index: 2;

  svg {
    display: block;
    height: var(--iconSize);
    width: var(--iconSize);
  }

  &.focus-ring {
    outline: auto;
  }

  &[data-theme='white'] {
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};
  }

  &[data-theme='yellow'] {
    --bgColor: ${brand.yellow};
    --fgColor: ${brand.black};
  }

  &[data-theme='green'] {
    --bgColor: ${brand.green};
    --fgColor: ${brand.black};
  }

  @media ${from(Device.Desktop)} {
    --iconSize: 14px;
    --size: 138px;
  }
`;
const Text = styled.span `
  ${headingStyles}

  display: block;
  font-size: 18px;
  line-height: 18px;
  margin: 0;
  max-width: 70%;

  @media ${from(Device.Desktop)} {
    font-size: 25px;
    line-height: 30px;
    max-width: 80px;
  }

  ${Container}[data-has-icon='true'] & {
    margin-bottom: 4px;
  }
`;
const FloatingActionButtonStyles = {
    Container,
    Text,
};
export default FloatingActionButtonStyles;
